module.exports = __webpack_public_path__ + "static/img/speech.17814976.png";